<mat-form-field class="mt-4 w-100">
    <mat-label class="form-label">Batch to assign</mat-label>
    <input type="number" [(ngModel)]="batchId" matInput>
</mat-form-field>
<app-leaderboard-page (actionEvent)="action($event)" [actionType]="actionType" [changeValue]='changeValue'></app-leaderboard-page>